import axios from "axios";
import React, { useEffect, useState } from "react";
import Step1 from "./TenderCreationForm/Step1";
import Step2 from "./TenderCreationForm/Step2";
import Step3 from "./TenderCreationForm/Step3";
import Step4 from "./TenderCreationForm/Step4";
import Step5 from "./TenderCreationForm/Step5";
import Step6 from "./TenderCreationForm/Step6";
import WorkItemsDetails from "./TenderCreationForm/WorkItemDetails";
import PreviewTender from "./TenderCreationForm/PreviewTender";
import { useLocation, useParams } from "react-router-dom";
import SelectApprovers from "./TenderCreationForm/SelectApprovers";

const CreateTender = () => {
  const [fetching, setFetching] = useState(false);
  const [tender, setTender] = useState();
  const user = JSON.parse(localStorage.getItem("user"));
  const [step, setStep] = useState(1);
  const { tenderId } = useParams();
  const [approvers, setApprovers] = useState({
    purchaseHead: "",
    technicalHead: "",
    financeHead: "",
  });
  const [noOfOpeners, setNoOfOpeners] = useState();
  const [openers, setOpeners] = useState([]);
  const [awardees, setAwardees] = useState({
    awardee1: "",
    awardee2: "",
  });
  const [filename, setFilename] = useState({
    ts1: "",
    ts2: "",
    ts3: "",
    ts4: "",
    ts5: "",
    ts6: "",
    ts7: "",
    ts8: "",
  });
  const [fileNames, setFileNames] = useState({
    tnc: "",
    serviceAgreement: "",
    protection: "",
  });
  const location = useLocation();

  const getDraft = async () => {
    setFetching(true);
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/draft?draftTenderId=${tenderId}`,
        { headers: { Authorization: `Bearer ${user.accessToken}` } }
      );
      setTender(res.data);
      setFilename({
        ...filename,
        ts1: res.data.ts1Filename,
        ts2: res.data.ts2Filename || "",
        ts3: res.data.ts3Filename || "",
        ts4: res.data.ts4Filename || "",
        ts5: res.data.ts5Filename || "",
        ts6: res.data.ts6Filename || "",
        ts7: res.data.ts7Filename || "",
        ts8: res.data.ts8Filename || "",
      });
      setFileNames({
        ...fileNames,
        tnc: res.data.tncFilename || "",
        serviceAgreement: res.data.serviceAgreementFilename || "",
        protection: res.data.protectionFilename || "",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setFetching(false);
    }
  };
  useEffect(() => {
    if (tenderId !== undefined) {
      getDraft();
    }
  }, [location]);
  return (
    <div style={{ position: "relative" }}>
      {fetching && <div className="loading-div"></div>}
      {step === 1 && (
        <Step1
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
        />
      )}
      {step === 2 && (
        <Step2
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
          getDraft={getDraft}
        />
      )}
      {step === 3 && (
        <Step3
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
        />
      )}
      {step === 4 && (
        <Step4
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
        />
      )}
      {step === 5 && (
        <Step5
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
          filename={filename}
          setFilename={setFilename}
        />
      )}
      {step === 6 && (
        <Step6
          tender={tender}
          setTender={setTender}
          user={user}
          setStep={setStep}
          fileNames={fileNames}
          setFileNames={setFileNames}
        />
      )}
      {step === 7 && (
        <WorkItemsDetails tender={tender} setStep={setStep} user={user} />
      )}
      {step === 8 && (
        <SelectApprovers
          tender={tender}
          setStep={setStep}
          user={user}
          approvers={approvers}
          setApprovers={setApprovers}
          noOfOpeners={noOfOpeners}
          setNoOfOpeners={setNoOfOpeners}
          openers={openers}
          setOpeners={setOpeners}
          awardees={awardees}
          setAwardees={setAwardees}
        />
      )}
      {step === 9 && (
        <PreviewTender
          tender={tender}
          setStep={setStep}
          user={user}
          approvers={approvers}
          noOfOpeners={noOfOpeners}
          openers={openers}
          awardees={awardees}
          filename={filename}
          fileNames={fileNames}
        />
      )}
    </div>
  );
};

export default CreateTender;
